import propertyInformationPanel from "./propertyInformationPanel.json";

export default {
  ...propertyInformationPanel,
};
